import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=3b6da1f3&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"
import style0 from "./_BaseButton.scss?vue&type=style&index=0&id=3b6da1f3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6da1f3",
  null
  
)

export default component.exports